import { render, staticRenderFns } from "./SettingsModal.vue?vue&type=template&id=c2eb8aba"
import script from "./SettingsModal.vue?vue&type=script&lang=js"
export * from "./SettingsModal.vue?vue&type=script&lang=js"
import style0 from "./SettingsModal.vue?vue&type=style&index=0&id=c2eb8aba&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2eb8aba')) {
      api.createRecord('c2eb8aba', component.options)
    } else {
      api.reload('c2eb8aba', component.options)
    }
    module.hot.accept("./SettingsModal.vue?vue&type=template&id=c2eb8aba", function () {
      api.rerender('c2eb8aba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/components/SettingsModal.vue"
export default component.exports